import axios from "axios";

export const updateDataExpociencias22 = async(props) => {
    const url = `${process.env.REACT_APP_BASE_URL}/api/expociencias22/${props.id}`;
    // console.log(url);

    const values = {...props}
    // console.log(values);

    var result = [];

    await axios.put(url, values)
    .then( response => {
        const data = response.data;
        result = {...data};
        if (data.exito === 1) {
            console.log("datos actualizados...");
        }
    })

    return result;
};
